import React from "react";
import "../styles/_ImageGallery.scss";

const ImageGallery = ({ images, visibleImageIds, setItemRef }) => {
  return (
    <div className="image-gallery">
      {images.map((image) => (
        <div
          key={image.id}
          className={`image-gallery-item ${visibleImageIds.has(image.id) ? "is-visible" : ""}`}
          data-image-id={image.id}
          ref={(el) => setItemRef(el, image.id)} // Set ref for IntersectionObserver
        >
          <img src={image.urls.small} alt={image.alt_description || "Photo"} />
        </div>
      ))}
    </div>
  );
};

export default ImageGallery;
